import React from 'react';
import { ChatConversation } from '../../helpers/chatQueueHelper';

interface ConversationTabsProps {
  conversations: Pick<ChatConversation, 'id' | 'title' | 'updatedAt'>[];
  activeId: string | null;
  onSelect: (id: string) => void;
  onClose: (id: string) => void;
  onNew: () => void;
}

/**
 * Pestañas de conversaciones del chat (KAN-218): hasta 4 conversaciones,
 * intercambiables, con cierre por tab y botón de nueva conversación.
 */
const ConversationTabs: React.FC<ConversationTabsProps> = ({ conversations, activeId, onSelect, onClose, onNew }) => {
  if (conversations.length === 0 && !activeId) return null;

  return (
    <div className="flex items-stretch gap-1 px-2 pt-2 bg-paper border-b border-hairline overflow-x-auto" role="tablist">
      {conversations.map((conv) => (
        <div
          key={conv.id}
          className={`group flex items-center gap-1 px-2 py-1.5 rounded-t-lg text-xs max-w-[10rem] whitespace-nowrap transition-colors ${
            conv.id === activeId
              ? 'bg-paper-2 text-ink font-semibold'
              : 'bg-transparent text-sage hover:bg-paper-2/50'
          }`}
        >
          <button
            role="tab"
            aria-current={conv.id === activeId ? 'true' : undefined}
            onClick={() => onSelect(conv.id)}
            className="truncate max-w-[7.5rem] focus:outline-none"
            title={conv.title}
          >
            {conv.title}
          </button>
          <button
            onClick={() => onClose(conv.id)}
            aria-label="Cerrar conversación"
            className="opacity-0 group-hover:opacity-100 focus:opacity-100 text-sage hover:text-danger px-0.5"
            title="Cerrar conversación"
          >
            ×
          </button>
        </div>
      ))}
      <button
        onClick={onNew}
        aria-label="Nueva conversación"
        title="Nueva conversación"
        className="px-2 py-1.5 rounded-t-lg text-xs text-sage hover:bg-paper-2/50 font-bold"
      >
        +
      </button>
    </div>
  );
};

export default ConversationTabs;
